module.exports = __webpack_public_path__ + "img/shwjw.58906b1d.png";